import { c as _c } from "react/compiler-runtime";
import { useMemo } from 'react';
import { getActiveCountry } from '@openclassrooms/translations';
import { getConfigurationCountry, getLocalisationConfig } from '@openclassrooms/localisation/services';
import { ROUTES, getPathName } from '@openclassrooms/routing';
import { translate } from '@openclassrooms/translations';
import { SlotNames } from '../constants/blueshift';
import type { SlotNamesToDatas } from '..';
const DATA_EVENT_TYPE = 'Banner';
const DATA_EVENT_CATEGORY = 'Clicked::Top';
const DATA_EVENT_ACTION = 'Promobar';
export default function useGetMarketingStaticContent(slot) {
  const $ = _c(40);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      label: "Lorem",
      url: "#lorem",
      variant: "primary",
      isTargetBlank: false,
      dataEvent: {
        type: "PopUp CTA",
        category: "Clicked::PopUp",
        action: "PopUp click",
        label: "First link"
      }
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      slotName: SlotNames.PopUp,
      slotDatas: [{
        show: false,
        content: {
          matchingUrl: "(/fr/|/fr|/fr/[^a-zA-Z0-9].*)$",
          isMatchingUrlRegExp: true,
          storageKey: "TEST",
          title: "Pr\xE9parez vos \xE9quipes aux enjeux de demain\xA0!",
          subheading: "Plus de 1\xA0900 entreprises font confiance \xE0 OpenClassrooms pour accompagner la mont\xE9e en comp\xE9tences de leurs \xE9quipes.",
          bullet_1: "20% th\xE9orie",
          bullet_2: "70% pratique",
          bullet_3: "100% en ligne",
          firstButton: t0,
          secondButton: {
            label: "Test",
            url: "#test",
            isTargetBlank: false,
            dataEvent: {
              type: "PopUp CTA",
              category: "Clicked::PopUp",
              action: "PopUp click",
              label: "Second link"
            }
          },
          mediaUrl: "https://cdn.getblueshift.com/pictures/268189/content/popup_img.png"
        }
      }]
    };
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      label: "Lorem",
      url: "#lorem",
      variant: "primary",
      isTargetBlank: false,
      dataEvent: {
        type: "PopUp CTA",
        category: "Clicked::PopUp",
        action: "PopUp click",
        label: "First link"
      }
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      slotName: SlotNames.NewFeature,
      slotDatas: [{
        show: false,
        content: {
          matchingUrl: "(/fr/|/fr|/fr/[^a-zA-Z0-9].*)$",
          isMatchingUrlRegExp: true,
          storageKey: "TEST",
          title: "Pr\xE9parez vos \xE9quipes aux enjeux de demain\xA0!",
          subheading: "Plus de 1\xA0900 entreprises font confiance \xE0 OpenClassrooms pour accompagner la mont\xE9e en comp\xE9tences de leurs \xE9quipes.",
          bullet_1: "20% th\xE9orie",
          bullet_2: "70% pratique",
          bullet_3: "100% en ligne",
          firstButton: t2,
          secondButton: {
            label: "Test",
            url: "#test",
            isTargetBlank: false,
            dataEvent: {
              type: "PopUp CTA",
              category: "Clicked::PopUp",
              action: "PopUp click",
              label: "Second link"
            }
          },
          mediaUrl: "https://cdn.getblueshift.com/pictures/268189/content/popup_img.png"
        }
      }]
    };
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  let t5;
  let t6;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = translate("wasc_accreditation.blue_banner.body");
    t5 = translate("wasc_accreditation.blue_banner.button");
    t6 = getPathName(ROUTES.WASC.INDEX);
    $[4] = t4;
    $[5] = t5;
    $[6] = t6;
  } else {
    t4 = $[4];
    t5 = $[5];
    t6 = $[6];
  }
  let t7;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = {
      show: true,
      content: {
        storageKey: "crm_top_banner_wasc_accreditation",
        body: t4,
        button: t5,
        link: t6,
        matchingUrl: "(/fr|/en|/fr/|/en/|/us|/us/)",
        isMatchingUrlRegExp: true,
        dataEvent: {
          type: DATA_EVENT_TYPE,
          category: DATA_EVENT_CATEGORY,
          action: DATA_EVENT_ACTION
        }
      }
    };
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t10;
  let t8;
  let t9;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = translate("predictive_crm.top_banner.global_page.body");
    t9 = translate("predictive_crm.top_banner.global_page.button");
    t10 = translate("predictive_crm.top_banner.global_page.link");
    $[8] = t10;
    $[9] = t8;
    $[10] = t9;
  } else {
    t10 = $[8];
    t8 = $[9];
    t9 = $[10];
  }
  let t11;
  let t12;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = {
      show: false,
      content: {
        storageKey: "crm_top_banner_global_page_termsUpdate",
        body: t8,
        button: t9,
        link: t10,
        matchingUrl: "(/fr|/en|/fr/|/en/|/dashboard/[^a-zA-Z0-9].*)",
        isMatchingUrlRegExp: true,
        dataEvent: {
          type: DATA_EVENT_TYPE,
          category: DATA_EVENT_CATEGORY,
          action: DATA_EVENT_ACTION
        }
      }
    };
    t12 = getLocalisationConfig("apprenticeship.hasJobMarketPlace") && getLocalisationConfig("apprenticeship.isEnabled");
    $[11] = t11;
    $[12] = t12;
  } else {
    t11 = $[11];
    t12 = $[12];
  }
  let t13;
  let t14;
  let t15;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = translate("predictive_crm.top_banner.home.body");
    t14 = translate("predictive_crm.top_banner.home.button");
    t15 = translate("predictive_crm.top_banner.home.link");
    $[13] = t13;
    $[14] = t14;
    $[15] = t15;
  } else {
    t13 = $[13];
    t14 = $[14];
    t15 = $[15];
  }
  let t16;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = {
      show: t12,
      content: {
        storageKey: "crm_top_banner_home_apprenticeshipJobs",
        body: t13,
        button: t14,
        link: t15,
        matchingUrl: "(/fr/|/fr|/fr/[^a-zA-Z0-9].*)$",
        isMatchingUrlRegExp: true,
        dataEvent: {
          type: DATA_EVENT_TYPE,
          category: DATA_EVENT_CATEGORY,
          action: DATA_EVENT_ACTION
        },
        isTargetBlankLink: true
      }
    };
    $[16] = t16;
  } else {
    t16 = $[16];
  }
  let t17;
  let t18;
  let t19;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = translate("predictive_crm.top_banner.funding.body");
    t18 = translate("predictive_crm.top_banner.funding.button");
    t19 = translate("predictive_crm.top_banner.funding.link");
    $[17] = t17;
    $[18] = t18;
    $[19] = t19;
  } else {
    t17 = $[17];
    t18 = $[18];
    t19 = $[19];
  }
  let t20;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t20 = {
      show: true,
      content: {
        storageKey: "crm_top_banner_funding_info",
        body: t17,
        button: t18,
        link: t19,
        matchingUrl: "(/fr/funding)",
        isMatchingUrlRegExp: true,
        dataEvent: {
          type: DATA_EVENT_TYPE,
          category: DATA_EVENT_CATEGORY,
          action: DATA_EVENT_ACTION
        },
        isTargetBlankLink: true
      }
    };
    $[20] = t20;
  } else {
    t20 = $[20];
  }
  let t21;
  let t22;
  let t23;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t21 = translate("predictive_crm.top_banner.apprenticeship.body");
    t22 = translate("predictive_crm.top_banner.apprenticeship.button");
    t23 = translate("predictive_crm.top_banner.apprenticeship.link");
    $[21] = t21;
    $[22] = t22;
    $[23] = t23;
  } else {
    t21 = $[21];
    t22 = $[22];
    t23 = $[23];
  }
  let t24;
  let t25;
  if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
    t24 = {
      show: true,
      content: {
        storageKey: "crm_top_banner_apprenticeship_info",
        body: t21,
        button: t22,
        link: t23,
        matchingUrl: "(/fr/apprenticeship)",
        isMatchingUrlRegExp: true,
        dataEvent: {
          type: DATA_EVENT_TYPE,
          category: DATA_EVENT_CATEGORY,
          action: DATA_EVENT_ACTION
        },
        isTargetBlankLink: true
      }
    };
    t25 = getConfigurationCountry(getActiveCountry());
    $[24] = t24;
    $[25] = t25;
  } else {
    t24 = $[24];
    t25 = $[25];
  }
  let t26;
  let t27;
  let t28;
  if ($[26] === Symbol.for("react.memo_cache_sentinel")) {
    t26 = translate("predictive_crm.top_banner.business.body");
    t27 = translate("predictive_crm.top_banner.business.button");
    t28 = translate("predictive_crm.top_banner.business.link");
    $[26] = t26;
    $[27] = t27;
    $[28] = t28;
  } else {
    t26 = $[26];
    t27 = $[27];
    t28 = $[28];
  }
  let t29;
  if ($[29] === Symbol.for("react.memo_cache_sentinel")) {
    t29 = {
      show: t25 === "FR",
      content: {
        storageKey: "crm_top_banner_business_frInfo",
        body: t26,
        button: t27,
        link: t28,
        matchingUrl: "(/fr/business)$",
        isMatchingUrlRegExp: true,
        dataEvent: {
          type: DATA_EVENT_TYPE,
          category: DATA_EVENT_CATEGORY,
          action: DATA_EVENT_ACTION
        },
        isTargetBlankLink: true
      }
    };
    $[29] = t29;
  } else {
    t29 = $[29];
  }
  let t30;
  let t31;
  let t32;
  if ($[30] === Symbol.for("react.memo_cache_sentinel")) {
    t30 = translate("predictive_crm.top_banner.forume.body");
    t31 = translate("predictive_crm.top_banner.forum.button");
    t32 = translate("predictive_crm.top_banner.forum.link");
    $[30] = t30;
    $[31] = t31;
    $[32] = t32;
  } else {
    t30 = $[30];
    t31 = $[31];
    t32 = $[32];
  }
  let t33;
  if ($[33] === Symbol.for("react.memo_cache_sentinel")) {
    t33 = {
      show: true,
      content: {
        storageKey: "crm_top_banner_forum_mentoring",
        body: t30,
        button: t31,
        link: t32,
        matchingUrl: "(/forum/)$",
        isMatchingUrlRegExp: true,
        dataEvent: {
          type: DATA_EVENT_TYPE,
          category: DATA_EVENT_CATEGORY,
          action: DATA_EVENT_ACTION
        }
      }
    };
    $[33] = t33;
  } else {
    t33 = $[33];
  }
  let t34;
  let t35;
  let t36;
  if ($[34] === Symbol.for("react.memo_cache_sentinel")) {
    t34 = translate("predictive_crm.top_banner.home_dashboard.body");
    t35 = translate("predictive_crm.top_banner.home_dashboard.button");
    t36 = translate("predictive_crm.top_banner.home_dashboard.link");
    $[34] = t34;
    $[35] = t35;
    $[36] = t36;
  } else {
    t34 = $[34];
    t35 = $[35];
    t36 = $[36];
  }
  let t37;
  if ($[37] === Symbol.for("react.memo_cache_sentinel")) {
    t37 = [t1, t3, {
      slotName: SlotNames.TopBanner,
      slotDatas: [t7, t11, t16, t20, t24, t29, t33, {
        show: false,
        content: {
          storageKey: "crm_top_banner_dashboard_courses",
          body: t34,
          button: t35,
          link: t36,
          matchingUrl: "(/fr/dashboard/courses)$",
          isMatchingUrlRegExp: true,
          dataEvent: {
            type: DATA_EVENT_TYPE,
            category: DATA_EVENT_CATEGORY,
            action: DATA_EVENT_ACTION
          }
        }
      }]
    }];
    $[37] = t37;
  } else {
    t37 = $[37];
  }
  const STATIC_CONTENTS = t37;
  let t38;
  if ($[38] !== slot) {
    t38 = STATIC_CONTENTS.find(content => content.slotName === slot);
    $[38] = slot;
    $[39] = t38;
  } else {
    t38 = $[39];
  }
  return t38 as SlotNamesToDatas[T];
}